'use client'

import { useEffect, Suspense } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'

const GTM_ID = 'GTM-MNMPKCJC'
const GTAG_ID = 'AW-17346748183'

function GTMPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    // Push page view to dataLayer on route change
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: pathname,
        search: searchParams.toString(),
      })
    }
  }, [pathname, searchParams])

  return null
}

export function GoogleTagManager() {
  return (
    <Suspense fallback={null}>
      <GTMPageView />
    </Suspense>
  )
}

export function GTMScript() {
  return (
    <>
      <script
        id="gtag-init"
        dangerouslySetInnerHTML={{
          __html: `
window.dataLayer=window.dataLayer||[];
function gtag(){dataLayer.push(arguments);}
gtag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied',functionality_storage:'granted',security_storage:'granted',wait_for_update:500});
try{if(localStorage.getItem('wf_consent')==='granted'){gtag('consent','update',{ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted',analytics_storage:'granted'});}}catch(e){}
gtag('js',new Date());
gtag('config','${GTAG_ID}');
          `.trim(),
        }}
      />
      {/* Google Tag Manager - Deferred Loading */}
      <script
        id="gtm-script"
        dangerouslySetInnerHTML={{
          __html: `
(function(w,d,s,l,i){w[l]=w[l]||[];
var n=d.currentScript&&d.currentScript.nonce;
function loadTags(){
  var f=d.getElementsByTagName(s)[0];
  var g=d.createElement(s);g.async=true;if(n){g.nonce=n;}g.src='https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}';f.parentNode.insertBefore(g,f);
  w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
  var j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
  j.async=true;if(n){j.nonce=n;j.setAttribute('nonce',n);}j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
}
window.addEventListener('load', function() {
  if ('requestIdleCallback' in w) { w.requestIdleCallback(loadTags, { timeout: 3000 }); }
  else { setTimeout(loadTags, 1200); }
});
})(window,document,'script','dataLayer','${GTM_ID}');
          `.trim(),
        }}
      />
    </>
  )
}

export function GTMNoscript() {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}

// Declare dataLayer type for TypeScript
declare global {
  interface Window {
    dataLayer: any[]
    gtag: (...args: any[]) => void
  }
}
